import { Action, createReducer, on } from '@ngrx/store';
import * as TimeSlotsActions from '../actions/timeslots.actions';
import { TimeSlots, TimeSlotsFilters, TimeSlotsDTO } from '../../commons/models/timeslots';

export interface TimeSlotsState {
    list: TimeSlotsDTO[];
    total: number;
    filters: TimeSlotsFilters;
    selectedTenantId: number;
    includes: string[],
    currentPage: number,
    perPage: number,
    order: string,
    direction: string,
    dialogId: string,
    selectionDialogId: string,
    selectedTimeSlots: TimeSlots[]
};

const initialState: TimeSlotsState = {
    list: [],
    total: 0,
    includes: [],
    currentPage: 1,
    perPage: 25,
    order: null,
    direction: null,
    filters: null,
    dialogId: null,
    selectionDialogId: null,
    selectedTenantId: 1,
    selectedTimeSlots: []
};

const timeSlotsReducer = createReducer(
    initialState,
  
    on(TimeSlotsActions.loadTimeSlotsCompleted, (state, { timeslots, currentPage, total, perPage, order, direction, filters, includes }) => {
        return { ...state, list: timeslots, currentPage, total, perPage, order, direction, filters, includes };
    }),
    on(TimeSlotsActions.timeSlotDialogOpened, (state, {dialogId}) => {
        return {...state, dialogId};
    }),
    on(TimeSlotsActions.selectTimeSlotSuccess, (state, { timeslot }) => {
        return { ...state, selectedTenants: []};
    }),

);

export function reducer(state: TimeSlotsState | undefined, action: Action) {
  return timeSlotsReducer(state, action);
}